<template lang="html">
    <div class="image-collection-items">
        <image-collection-item v-for="item in items" :item="item" :key="item.id" @itemDeleted="deleteItem"></image-collection-item>
        <div class="align-center">
            <button type="button" class='align-center big-purple-button' @click="addItem">Add more</button>
        </div>
    </div>
</template>

<script>
export default {
  props: ['default', 'minId'],
  data() {
    return {
      items: [],
      lastId: 1
    };
  },
  methods: {
    addItem() {
      if (this.items.length < 10) {
        this.lastId = this.lastId + 1;
        this.items.push({
          id: this.lastId
        });
      }
    },
    deleteItem(removedItem) {
      this.items = this.items.filter(function (item) {
        if (item.id !== removedItem.id) return true;
      });
      if (!this.items.length) {
        this.lastId = this.lastId + 1;
        this.items.push({
          id: this.lastId
        });
      }
    }
  },
  mounted() {
    let items = [];
    if (this.minId === undefined) {
      this.lastId = 1;
    } else {
      this.lastId = this.minId;
    }
    if (this.default) {
      this.default.forEach((defaultItem) => {
        items.push(defaultItem);
      });
      this.lastId = this.default.length + 1;
    } else {
      items.push({
        id: this.lastId
      });
    }
    this.items = items;
  }
};
</script>